import React from "react";

export const FloorplanPlaceholder: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 225"
    preserveAspectRatio="xMidYMid slice"
    style={{ width: "100%", height: "100%", display: "block" }}
    role="img"
    aria-label="Floor plan coming soon"
  >
    <rect width="400" height="225" fill="#E8EAED" />
    <g fill="none" stroke="#BABDC2" strokeWidth="2">
      <rect x="30" y="25" width="340" height="175" />
      <line x1="180" y1="25" x2="180" y2="125" />
      <line x1="30" y1="125" x2="370" y2="125" />
      <line x1="270" y1="125" x2="270" y2="200" />
      <rect x="45" y="40" width="120" height="70" fill="#F8F9FA" />
      <rect x="195" y="40" width="160" height="70" fill="#F8F9FA" />
      <rect x="45" y="140" width="210" height="45" fill="#F8F9FA" />
      <rect x="285" y="140" width="70" height="45" fill="#F8F9FA" />
      <circle cx="105" cy="75" r="14" fill="#D5D7DB" />
      <rect x="210" y="55" width="40" height="40" fill="#D5D7DB" />
      <rect x="310" y="55" width="30" height="12" fill="#D5D7DB" />
      <rect x="300" y="155" width="40" height="18" fill="#D5D7DB" />
    </g>
    <rect x="0" y="85" width="400" height="55" fill="rgba(255,255,255,0.88)" />
    <text
      x="200"
      y="118"
      textAnchor="middle"
      fill="#2C2D30"
      fontFamily="'Helvetica Neue', Arial, sans-serif"
      fontSize="24"
      fontWeight="700"
      letterSpacing="1"
    >
      FLOOR PLANS COMING SOON
    </text>
  </svg>
);
